(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/observability-web/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/core/observability-web/assets/javascripts/utils.js');
"use strict";


(function (_svs$core$observabili, _svs$core$observabili2) {
  'use strict';

  const _window$OpenTelemetry = window.OpenTelemetry.api,
    trace = _window$OpenTelemetry.trace,
    context = _window$OpenTelemetry.context,
    defaultTextMapGetter = _window$OpenTelemetry.defaultTextMapGetter,
    defaultTextMapSetter = _window$OpenTelemetry.defaultTextMapSetter,
    SpanKind = _window$OpenTelemetry.SpanKind,
    SpanStatusCode = _window$OpenTelemetry.SpanStatusCode;
  const WebTracerProvider = window.OpenTelemetry.sdkTraceWeb.WebTracerProvider;
  const _window$OpenTelemetry2 = window.OpenTelemetry.sdkTraceBase,
    AlwaysOnSampler = _window$OpenTelemetry2.AlwaysOnSampler,
    BatchSpanProcessor = _window$OpenTelemetry2.BatchSpanProcessor;
  const OTLPTraceExporter = window.OpenTelemetry.exporterTraceOtlpHttp.OTLPTraceExporter;
  const W3CTraceContextPropagator = window.OpenTelemetry.core.W3CTraceContextPropagator;
  const resourceFromAttributes = window.OpenTelemetry.resources.resourceFromAttributes;
  const ZoneContextManager = window.OpenTelemetry.contextZone.ZoneContextManager;
  const spanProcessors = [];
  const host = (_svs$core$observabili = svs.core.observability.data) === null || _svs$core$observabili === void 0 ? void 0 : _svs$core$observabili.host;
  const disabled = Boolean((_svs$core$observabili2 = svs.core.observability.data) === null || _svs$core$observabili2 === void 0 ? void 0 : _svs$core$observabili2.disabled);
  if (host && !disabled) {
    const endpoint = host.endsWith('v1/traces') ? host : "".concat(host, "/v1/traces");
    const exporter = new OTLPTraceExporter({
      url: endpoint,
      httpAgentOptions: {
        keepAlive: true,
        timeout: 1000
      }
    });
    spanProcessors.push(new BatchSpanProcessor(exporter, svs.core.observability.batchspanconfig));
  }
  const provider = new WebTracerProvider({
    sampler: new AlwaysOnSampler(),
    resource: resourceFromAttributes({
      'service.name': "".concat(svs.core.config.data.svsconfig.site, "_").concat(svs.core.config.data.svsconfig.tribe),
      'service.version': svs.core.config.data.svsconfig.ver,
      'deployment.environment': svs.core.observability.data.environment
    }),
    spanProcessors
  });
  const propagator = new W3CTraceContextPropagator();
  const contextManager = new ZoneContextManager();
  provider.register({
    propagator,
    contextManager
  });
  const inject = (carrier, span) => {
    const ctx = trace.setSpan(context.active(), span);
    propagator.inject(ctx, carrier, defaultTextMapSetter);
    return carrier;
  };
  const extract = carrier => {
    const ctx = propagator.extract(context.active(), carrier, defaultTextMapGetter);
    return ctx;
  };
  svs.core.observability.provider = provider;
  svs.core.observability.context = context;
  svs.core.observability.trace = trace;
  svs.core.observability.inject = inject;
  svs.core.observability.extract = extract;
  svs.core.observability.SpanKind = SpanKind;
  svs.core.observability.SpanStatusCode = SpanStatusCode;
})();

 })(window);